import React, {memo} from 'react';
import {View} from 'react-native';

import {StyleSheet} from 'react-native';
import {ConsultationMessageVideoCallBubble} from '..';
import {colorPalette} from '../../../core/config/color.config';

import {RNEText} from '../../components';
import {ConsultationRequestResBody} from '../../server/types/consultation.types';
import {CodedConversationMessages} from '../../server/types/conversation.types';
import {width, height, totalSize} from 'react-native-dimension';

import {formatToMessageTime} from '../../utils/date.utils';

interface ConsultationMessageBubbleProps {
  message: string;
  timestamp: Date;
  owner?: boolean;
  isPatient?: boolean;
  serviceRequest?: ConsultationRequestResBody;
  latestVideoCallRequestTimestamp?: Date;
  onStartGenerating: () => void;
  onStopGenerating: () => void;
  onReloadChat: () => void;
}

const ConsultationMessageBubble = (props: ConsultationMessageBubbleProps) => {
  return (
    <View>
      <View style={styles.timestamp}>
        <RNEText
          label={formatToMessageTime(props.timestamp)}
          color="grey"
          variant="button"
          weight="600"
        />
      </View>
      <View
        style={[
          styles.messageContainer,
          // eslint-disable-next-line react-native/no-inline-styles
          !props.message.includes('HCAPPNTMNT_VIDEO_CALL') && {
            alignItems: props.owner ? 'flex-end' : 'flex-start',
          },
        ]}>
        <View
          style={[
            !props.message.includes('HCAPPNTMNT_VIDEO_CALL') &&styles.messageWrapper,
            // eslint-disable-next-line react-native/no-inline-styles
            {
              borderTopRightRadius: props.owner ? 0 : 12,
              borderTopLeftRadius: props.owner ? 12 : 0,
              
            },

             !props.message.includes('HCAPPNTMNT_VIDEO_CALL') && {
                backgroundColor: props.isPatient
                ? colorPalette.purple
                : colorPalette.success,
             }
          ]}>
          {props.message.includes('HCAPPNTMNT_VIDEO_CALL') ? (
            <ConsultationMessageVideoCallBubble
              message={props.message}
              timestamp={props.timestamp}
              owner={props.owner}
              isPatient={props.isPatient}
              serviceRequest={props.serviceRequest}
              onStartGenerating={props.onStartGenerating}
              onStopGenerating={props.onStopGenerating}
              onReloadChat={props.reloadChat}
              latestVideoCallRequestTimestamp={
                props.latestVideoCallRequestTimestamp
              }
            />
          ) : (
            <RNEText label={props.message} color="white" variant="button" />
          )}

          {/* {props.message === CodedConversationMessages.VIDEO_CALL_TRIGGER ||
          props.message === CodedConversationMessages.VIDEO_CALL_ACCEPT ? (
            <ConsultationMessageVideoCallBubble
              message={props.message}
              timestamp={props.timestamp}
              owner={props.owner}
              isPatient={props.isPatient}
              serviceRequest={props.serviceRequest}
              latestVideoCallRequestTimestamp={
                props.latestVideoCallRequestTimestamp
              }
            />
          ) : (
            <RNEText label={props.message} color="white" variant="button" />
          )} */}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  timestamp: {
    alignItems: 'center',
    marginTop: 20,
  },
  messageContainer: {
    marginTop: 12,
  },
  messageWrapper: {
    width: '60%',
    padding: height(2),
    paddingLeft: width(6),
    paddingRight: width(6),
    borderRadius: totalSize(2),
  },
  buttonStyle: {
    padding: 8,
  },
  buttonTextStyle: {
    color: colorPalette.blackLight,
  },
});

export default memo(ConsultationMessageBubble);
